module.exports = __webpack_public_path__ + "static/bild_dummy-9bf2815b6578a0567cb5bc38d1bf324b.JPG";